import { defineStore } from 'pinia';
import { Cart, CustomerRequestQuotes } from '~/composables';
import { RequestQuoteFormFields } from '../types';

interface RequestQuoteState {
  currentCustomerQuoteCart: Cart | null;
  requestQuoteFormValues: RequestQuoteFormFields;
  withRemarks: boolean;
  customerRequestQuotes: CustomerRequestQuotes;
}

export const useRequestQuoteStore = defineStore('requestQuote', {
  state: (): RequestQuoteState => ({
    currentCustomerQuoteCart: null,
    requestQuoteFormValues: {
      email: '',
      firstName: '',
      lastName: '',
      remarks: '',
    },
    withRemarks: false,
    customerRequestQuotes: null,
  }),
  actions: {
    setCustomerQuoteCart(cart: Cart) {
      this.currentCustomerQuoteCart = cart;
    },
    setRequestQuoteFormValues(values: RequestQuoteFormFields) {
      this.requestQuoteFormValues = values;
    },
    setWithRemarks(remarksFlag: boolean) {
      this.withRemarks = remarksFlag;
    },
    setCustomerRequestQuotes(quotes: CustomerRequestQuotes) {
      this.customerRequestQuotes = quotes;
    },
  },
});
